import React from 'react';
import useOrganizationInvitationDefinitions from '../../../../../../../hooks/api/useOrganizationInvitationDefinitions';
import { useIsDisabledByParent } from '../../../../../../v2BaseComponents/IsDisabledProvider';
import { AnimateLoadedContent } from '../../../../../../v2BaseComponents/Loader';
import EditInvitationDefinitionForm from './EditInvitationDefinitionForm';

export type EditInvitationDefinitionSideDrawerContentOwnProps = {
    invitationDefinitionId: string;
    onClose: (force: boolean) => void;
};

export type EditInvitationDefinitionSideDrawerContentProps = EditInvitationDefinitionSideDrawerContentOwnProps;

const EditInvitationDefinitionSideDrawerContent: React.FC<EditInvitationDefinitionSideDrawerContentProps> = ({
    invitationDefinitionId,
    onClose,
}) => {
    const {
        isUpdatingInvitationDefinition,
        updateInvitationDefinition,
        invitationDefinition,
        isLoadingInvitationDefinition,
    } = useOrganizationInvitationDefinitions({
        onUpdateInvitationDefinitionSuccess: () => onClose(true),
        invitationDefinitionId,
    });
    const isDisabledByParent = useIsDisabledByParent(isUpdatingInvitationDefinition);

    return (
        <AnimateLoadedContent isLoading={isLoadingInvitationDefinition || !invitationDefinition}>
            {() => (
                <EditInvitationDefinitionForm
                    invitationDefinition={invitationDefinition!}
                    onUpdate={(invitationDefinition) =>
                        updateInvitationDefinition({
                            invitationDefinition,
                            invitationDefinitionId,
                        })
                    }
                    isDisabled={isDisabledByParent}
                    onCancel={() => onClose(true)}
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditInvitationDefinitionSideDrawerContent);
